import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import DBLOGO from "./ui/db_logo.svg";
import "./Header.css";

const NAV_LINKS = [
    { to: "/", label: "Home" },
    { to: "/services", label: "Services" },
    { to: "/defence", label: "Defence" },
    { to: "/projects", label: "Projects" },
    { to: "/videos", label: "Videos" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
];

export const Header = () => {
    const location = useLocation();
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 16);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const isHome = location.pathname === "/";
    const showSolid = scrolled || !isHome;

    return (
        <header
            data-testid="site-header"
            className={`fixed-top header-transition ${showSolid ? "header-scrolled" : "header-top"}`}
        >
            <div className="container-db d-flex align-items-center justify-content-between header-inner">
                <Link
                    to="/"
                    data-testid="brand-logo-link"
                    className="d-flex align-items-center gap-2 text-decoration-none"
                    onClick={() => setOpen(false)}
                >
                    <img src={DBLOGO} alt="DB Productions" style={{ width: '80%', height: '80%', objectFit: 'contain', objectPosition: 'left' }} />

                </Link>

                <nav className="d-none d-lg-flex align-items-center gap-4" data-testid="primary-nav">
                    {NAV_LINKS.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            end={l.to === "/"}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className={({ isActive }) =>
                                `font-mono-tech nav-link-custom  ${isActive ? "active" : ""}`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>

                <Link
                    to="/contact"
                    data-testid="nav-contact-cta"
                    className="d-none d-lg-inline-flex btn-primary-custom font-mono-tech text-dark fw-bold ms-3"
                >
                    Start a Project <ArrowUpRight size={14} strokeWidth={2.5} />
                </Link>

                <button
                    data-testid="mobile-menu-toggle"
                    aria-label="Toggle menu"
                    className="d-lg-none btn btn-link text-white p-2"
                    onClick={() => setOpen((v) => !v)}
                >
                    {open ? <X /> : <Menu />}
                </button>
            </div>

            {/* Mobile drawer */}
            {open && (
                <div
                    data-testid="mobile-nav"
                    className="d-lg-none mobile-nav-drawer"
                >
                    <div className="container-db py-4 d-flex flex-column gap-3 gap-sm-4">
                        {NAV_LINKS.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                end={l.to === "/"}
                                onClick={() => setOpen(false)}
                                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                                className="font-heading mobile-nav-link"
                            >
                                {l.label}
                            </NavLink>
                        ))}
                        <Link
                            to="/contact"
                            onClick={() => setOpen(false)}
                            data-testid="mobile-nav-contact" style={{ fontWeight: 800 }}
                            className="mt-2 btn-primary-custom font-mono-tech justify-content-center text-dark fw-bold"
                        >
                            Start a Project <ArrowUpRight size={14} />
                        </Link>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;
